__turbopack_context__.v({
  "evervizEmbed": "CustomPortableTextComponents-module-scss-module__MwAzyW__evervizEmbed",
  "figure": "CustomPortableTextComponents-module-scss-module__MwAzyW__figure",
  "highlight": "CustomPortableTextComponents-module-scss-module__MwAzyW__highlight",
  "inlineContentList": "CustomPortableTextComponents-module-scss-module__MwAzyW__inlineContentList",
  "inlineContentListItem": "CustomPortableTextComponents-module-scss-module__MwAzyW__inlineContentListItem",
  "link": "CustomPortableTextComponents-module-scss-module__MwAzyW__link",
  "paragraph": "CustomPortableTextComponents-module-scss-module__MwAzyW__paragraph",
  "strong": "CustomPortableTextComponents-module-scss-module__MwAzyW__strong",
  "twitterBlock": "CustomPortableTextComponents-module-scss-module__MwAzyW__twitterBlock",
  "youtubeBlock": "CustomPortableTextComponents-module-scss-module__MwAzyW__youtubeBlock",
});
